import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DrawerBody, TextField } from '@one-thd/sui-atomic-components';
import { GROUP_ALREADY_EXITS_ERROR, SCREENS } from '../../AddToConstants';
import { validateGroupName } from '../../AddToHelpers';
import {
  useCreateGroup,
  projectDetailsModel,
  createGroupModel,
  useProjectDetails
} from '../../hooks/useProjects';

export const ProjectsGroupSelection = ({
  projectId,
  handleClose,
  onCreateGroup,
  getGroupName,
  checkGroup,
  groupErrorMessaging,
  setShowSuccessMessage,
  setScreen,
  onClose
}) => {
  const [groupName, setGroupName] = useState();
  const [errorMessaging, setErrorMessaging] = useState('');
  const [isEnterPress, setIsEnterPress] = useState(false);
  const { DEFAULT } = SCREENS;
  const { projectData, projectRefetch } = useProjectDetails({ projectId });

  const {
    defaultListId,
    defaultListMutationKey
  } = projectData?.projectDetails || {};

  const { createGroup, createGroupResponse } = useCreateGroup({
    projectId,
    listId: defaultListId,
    mutationKey: defaultListMutationKey,
    groupName
  });

  const handleNameValidation = (value) => {
    if (isEnterPress) {
      return;
    }
    const { isError, errorMessage } = validateGroupName(value);
    if (isError) {
      setErrorMessaging(errorMessage);
    } else {
      setErrorMessaging('');
    }
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      setIsEnterPress(true);
    } else if (!isEnterPress) {
      setIsEnterPress(false);
    }
  };

  const handleOnChange = (event) => {
    const { value } = event.target;
    handleNameValidation(value);
    setGroupName(value);
    getGroupName(value, errorMessaging);
  };

  const handleSubmit = async (submitEvent) => {
    submitEvent.preventDefault();
    if (!errorMessaging) {
      if (!groupName) {
        setErrorMessaging('Please enter a group name');
        setErrorMessaging(GROUP_ALREADY_EXITS_ERROR);
      } else {
        await createGroup();
      }
    }
  };

  useEffect(() => {
    if (createGroupResponse?.data?.createProjectListGroup?.groupId) {
      if (!onCreateGroup) {
        LIFE_CYCLE_EVENT_BUS.trigger('projects: group modification', {
          groupAction: 'group created'
        });
      }
      setShowSuccessMessage(true);
      setScreen(DEFAULT);
      projectRefetch();
      onClose(true);
    }
    if (createGroupResponse?.error) {
      if (createGroupResponse?.error?.message.includes(GROUP_ALREADY_EXITS_ERROR)) {
        setErrorMessaging('do you think ?');
      }
    }

  }, [createGroupResponse?.data, createGroupResponse?.error]);

  return (
    <>
      <DrawerBody className="sui-p-0">
        <form
          onSubmit={handleSubmit}
        >
          <TextField
            id="group-name-pro"
            // label="Group Name"
            placeholder="Enter Group Name"
            type="text"
            onBlur={() => { handleNameValidation(groupName); }}
            value={groupName}
            disabled={!checkGroup}
            fullWidth
            onChange={(event) => { handleOnChange(event); }}
            onKeyDown={(event) => { handleKeyDown(event); }}
            status={
              groupErrorMessaging ? 'error' : null
            }
            statusMessage={
              groupErrorMessaging || ''
            }
            InputProps={{
              inputProps: {
                'data-testid': 'group-name-input'
              }
            }}
          />
        </form>
      </DrawerBody>
    </>
  );
};

ProjectsGroupSelection.propTypes = {
  projectId: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  onCreateGroup: PropTypes.func
};

ProjectsGroupSelection.defaultProps = {
  onCreateGroup: null
};

ProjectsGroupSelection.dataModel = {
  projectDetailsModel,
  createGroupModel
};
